import { pagination } from "instantsearch.js/es/widgets";

const paginationWidget = () =>
  pagination({
    container: "#pagination",
    scrollTo: document.getElementById("services-refinement"),
    cssClasses: {
      list: "d-flex flex-row flex-wrap justify-content-center list-unstyled",
      link: "p-2",
      pageItem:
        "border border-primary rounded mx-1 cursor-pointer dark-paginate-btn",
      disabledItem: "text-muted mx-1",
      selectedItem:
        "bg-warning border border-warning rounded mx-1 cursor-pointer dark-paginate-active-btn",
    },
  });

export default paginationWidget;
